import {extractOrderRequest} from "../place-multi-equity-order-wizard/util/MultiAccountEquityWizardOrderUtil";
import {MultiAccountTradeService} from "../services/MultiAccountTradeService";
import {MultiAccountOrderRequest} from "../services/models/PlaceMultiAccountOrderRequest";
import {MultiAccountEquityWizardData} from "../place-multi-equity-order-wizard/models/MultiAccountEquityWizardData";
import {MultiAccountOrdersDialogService} from "./MultiAccountOrdersDialogService";

export class MultiAccountEquityTicketService {

    public static readonly id = "multiAccountEquityTicketService";

    /** @ngInject */
    public constructor(
        private readonly multiAccountOrderDialogService: MultiAccountOrdersDialogService,
        private readonly multiAccountTradeService: MultiAccountTradeService) {
    }

    public async openWizard(wizardData?: MultiAccountEquityWizardData): Promise<void> {
        const data = await this.multiAccountOrderDialogService.openMultiAccountDialog(wizardData);
        const request = extractOrderRequest(data);
        if (request !== null) {
            await this.placeOrder(request);
        }

    }

    private async placeOrder(requestData: MultiAccountOrderRequest) {
        return this.multiAccountTradeService.placeMultiAccountTrades(requestData);
    }
}
